module.exports = __webpack_public_path__ + "img/icon-edit-underline-link.6406d719.svg";